<template>
    <v-chart  
    style="width:98%;height:240px;left:0%;"
    :auto-resize="true"
    ref="chart"/>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart,LineChart  } from "echarts/charts";
// import ECharts from 'echarts';
import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent
]);
export default {
    name:'chartfundvalue',
    components:{
        VChart
    },
    provide: {
        [THEME_KEY]: "light"
    },
    created(){
        setTimeout(()=>{
            this.setoption();
        },1000)
        
    },
    mounted() {
        this.$nextTick(()=>{
            this.$refs.chart.clear();
            this.setoption();
            window.addEventListener("resize", this.resizeTheChart);
        })
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeTheChart);
    },
    methods:{
        resizeTheChart() {
            if (this.$refs.chart) {
                this.$refs.chart.resize();
            }
        },
        setoption(){
            this.$refs.chart.setOption(this.option, true);
        }
    },
    props:{
       days:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       values:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       trends:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       }
    },
    data(){
        return {
            option:{
                dataZoom: [
                    {
                        type: 'slider',
                        xAxisIndex: 0,
                        filterMode: 'filter',
                        start: this.days.length-10,
                        end: this.days.length,
                        height: 14,
                        bottom: 20,
                        borderColor: 'transparent',
                        backgroundColor: '#e2e2e2',
                        handleColor: '#aab6c6',
                        handleSize: 20,
                        handleStyle: {
                            borderColor: '#aab6c6',
                            shadowBlur: 4,
                            shadowOffsetX: 1,
                            shadowOffsetY: 1,
                            shadowColor: '#e5e5e5'
                        },
                    }
                ],
                grid:{
                    left: '0%',
                    top:'15%',
                    right:'3%',
                    bottom:'12%'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            
                        type: 'shadow'    
                    },
                    formatter: function (params) {
                        let html=params[0].name+"<br>";
                        for(let i=0;i<params.length;i++){
                            html+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+params[i].color+';"></span>'
                            if(params[i].seriesName=="Daily Change"){
                                if(params[i].value<0){
                                    html+=params[i].seriesName+": "+'<span style="color:red">'+params[i].value+"%</span><br>"
                                }else{
                                    html+=params[i].seriesName+": "+'<span style="color:green">'+params[i].value+"%</span><br>"
                                }
                            }else{
                                
                                html+=params[i].seriesName+": "+'<span style="color:black">$'+params[i].value+"</span><br>";
                            
                            }
                                
                        }
                        return html;
                    }

                },
                toolbox: {
                    itemSize:16,
                    feature: {
                        // dataView: {show: true, readOnly: false},
                        magicType: {show: true, type: ['line']},
                        // restore: {show: true},
                        myToolRestore: {
                            show: true,
                            title: "Restore",
                            icon:
                                "path://M512 981.333333c-209.866667 0-396.693333-126.026667-466.293333-314.08a35.52 35.52 0 0 1 23.626666-44.426666 38.613333 38.613333 0 0 1 48 20.693333c58.666667 158.933333 217.013333 265.493333 394.666667 265.6s336-106.666667 394.666667-266.133333a37.6 37.6 0 0 1 28.853333-23.626667 38.986667 38.986667 0 0 1 35.786667 11.946667 34.773333 34.773333 0 0 1 7.146666 35.36c-69.386667 188.373333-256.48 314.666667-466.453333 314.666666z m431.36-574.08a37.92 37.92 0 0 1-35.946667-24.266666C849.386667 222.56 690.613333 114.88 512 114.72S174.72 222.346667 116.746667 382.773333A38.72 38.72 0 0 1 69.333333 403.733333a35.786667 35.786667 0 0 1-24.106666-44.373333C113.333333 169.866667 301.013333 42.666667 512 42.666667s398.666667 127.306667 467.146667 316.96a34.56 34.56 0 0 1-4.906667 32.64 38.933333 38.933333 0 0 1-30.88 14.986666z",
                            onclick: () => {
                                this.$refs.chart.clear();
                                this.$refs.chart.setOption(this.option);
                            },
                        },
                        saveAsImage: {show: true},

                    }
                },
                xAxis:[
                    {
                        type: 'category',
                        data: this.days,
                        axisLine:{
                            show: false
                        },
                        axisLabel:{
                            inside: true
                        },
                        axisTick:{
                            show:false
                        },
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        // name: 'Balance(m)',
                        min: function (value) {
                            return value/5;
                        },
                        max: function (value) {
                            return value.max;
                        },
                        axisLabel: {
                            show: true,
                            inside: true,
                            formatter: function(value,index){
                                return value/1000000;
                            }
                        }
                    },
                    {
                        type: 'value',
                        // name: 'Trend(%)',
                        boundaryGap: [0, '100%'],
                        axisLabel: {
                            show: false
                        },
                        splitLine:{
                            show:false
                        }
                    }
                ],
                series: [
                {
                        name: 'Fund Balance',
                        type: 'bar',
                        data: this.values,
                        barWidth: '40%',
                        itemStyle:{
                            color:'#4361ee',
                            opacity:0.5,
                        },
                        
                    },
                    {
                        name: 'Daily Change',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.trends,
                        symbolSize:1,
                        itemStyle:{
                            color:'#3a0ca3',
                        },
                        // areaStyle:{
                        //     origin: 'start',
                        //     color: {
                        //         type: 'linear',
                        //         x: 0,
                        //         y: 0,
                        //         x2: 0,
                        //         y2: 1,
                        //         colorStops: [{
                        //             offset: 0, color: '#4361ee' 
                        //         }, {
                        //             offset: 1, color: '#1C00ff00' 
                        //         }],
                        //         global: false 
                        //     }
                        // }
                        
                    }
                ]
            }
        }
    }
}
</script>